import * as React from 'react';
import { Box } from '@mui/material';
import { connect } from "react-redux";
import ReactGA from "react-ga4";
import { MarketingPage, MarketingCard } from '../../app/components/marketing';

export const Careers = () => {
  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/careers", title: "Careers" });
  }, []);

  return (
    <MarketingPage maxWidth="md">
      <MarketingCard contentSx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          component="iframe"
          src="https://docs.google.com/forms/d/e/1FAIpQLSfZlXZIRrlMlLCEDHAjvo0PWolrT1WdYKGtnWozE6N6FHKfSw/viewform?embedded=true"
          title="Careers application form"
          sx={{
            width: '100%',
            maxWidth: 640,
            height: { xs: 900, md: 1116 },
            border: 0,
          }}
        />
      </MarketingCard>
    </MarketingPage>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Careers);
